<template>
  <div>
    <section id="wat-wij-doen" class="content-wrapper page">
      <section class="row header">
        <ul class="breadcrumb">
          <li><router-link class="link" to="/">Home</router-link></li>

          <li>
            <inline-svg
              src="/images/icons/chevron-right-solid.svg"
            ></inline-svg>
            <span>Wat wij doen</span>
          </li>
        </ul>

        <div class="col text">
          <h1>Wat wij doen</h1>
          <h2>Printen voor professionals</h2>
        </div>
      </section>
      <section class="row text-3 stappen">
        <div class="col text">
          <h3>Print uitbesteden</h3>
          <p>
            Wij verzorgen meer dan 160.000 printopdrachten voor professionals
            per jaar, vanuit vijf locaties verspreid over het land. Wij regelen
            uw printopdracht van A tot Z makkelijk en snel. Bent u toe aan het
            uitbesteden van uw print- en repro-opdrachten? Kijk hier hoe wij uw
            printproducten efficiënt, kostenbesparend, veilig en betrouwbaar
            uitvoeren.
          </p>
          <router-link class="link-button" to="/print-uitbesteden"
            >Lees meer over print uitbesteden</router-link
          >
        </div>
        <div class="col text">
          <h3>Print aanbesteden</h3>
          <p>
            Als full service grafisch dienstverlener verzorgen wij
            printopdrachten voor gemeenten, onderwijsorganisaties en andere
            (overheids)instellingen. Zij kozen na een Europese of onderhandse
            aanbesteding voor Koninklijke Rijnja. Oriënteert uw organisatie zich
            op een aanbesteding voor uw printopdrachten? Lees hier meer over
            onze aanpak.
          </p>
          <router-link class="link-button" to="/print-aanbesteden"
            >Lees meer over print aanbesteden</router-link
          >
        </div>

        <div class="col text">
          <h3>Secured printing</h3>
          <p>
            Bij printopdrachten van AVG-gevoelige documenten waarborgen wij de
            beveiliging en vertrouwelijkheid door middel van een speciaal
            ontwikkeld en gecertificeerd secured printing proces. Lees hier meer
            over gegevensbescherming bij Koninklijke Rijnja.
          </p>
          <router-link class="link-button" to="/secured-printing"
            >Lees meer over secured printing</router-link
          >
        </div>
      </section>

      <section class="row image-row">
        <img
          class=""
          src="@/images/pages/rijnja-besteld-en-geleverd-door-heel-nederland.svg"
        />
      </section>

      <section id="" class="row">
        <div class="col text">
          <h2>Digitaliseren en archiveren</h2>
          <p>
            Wij digitaliseren documenten, van één rapport of bouwtekening tot
            een compleet archief, en leveren digitale, doorzoekbare informatie
            terug. Ruimte scheppen, geen risico meer lopen op verlies of (brand-
            en water)schade. Een beter overzicht creëren, de toegankelijkheid
            van uw archief vergroten. Kijk hier hoe u uw papieren archief achter
            u laat.
          </p>
          <router-link class="link-button" to="/digitaliseren"
            >Lees meer over digitaliseren en archiveren</router-link
          >
        </div>
        <div class="col image digitaliseren">
          <img
            class="img-digitaliseren"
            src="@/images/pages/digitaliseren-archiveren.svg"
          />
        </div>
      </section>

      <section id="" class="row reverse">
        <div class="col text">
          <h2>Signing</h2>
          <p>
            Naast printoplossingen op maat bieden wij ook duizenden
            kant-en-klare stickers en borden aan voor bouwplaatsen, winkels,
            kantoren, scholen, openbare ruimtes, etc. De collectie wordt
            voortdurend uitgebreid.
          </p>
          <router-link class="link-button" to="/printstore"
            >Bekijk hier ons signing aanbod</router-link
          >
        </div>
        <div class="col image digitaliseren">
          <img class="img-digitaliseren" src="@/images/pages/printstore.svg" />
        </div>
      </section>
      <!--
      <section class="row ">
        <div class="col text">
          <h3>Secured printing</h3>
          <p>
            Bij printopdrachten van AVG-gevoelige documenten waarborgen wij de
            beveiliging en vertrouwelijkheid door middel van een speciaal
            ontwikkeld en gecertificeerd secured printing proces. Lees hier meer
            over gegevensbescherming bij Koninklijke Rijnja.
          </p>
          <router-link class="link-button" to="/secured-printing"
            >Lees meer over secured printing</router-link
          >
        </div>
        <div class="col image">
          <img
            class="bestellen-bezorgen"
            src="@/images/pages/bestellen-bezorgen.svg"
          />
        </div>
      </section> -->

      <section class="row" id="contact">
        <div class="col-single">
          <h2>Wilt u meer weten over onze diensten?</h2>
          <p>
            Benieuwd naar wat Koninklijke Rijnja voor u kan betekenen? Neem dan
            contact met ons op via onderstaand formulier.
          </p>

          <contact-form
            recipient="verkoop@rijnja.nl"
            class="form"
            subject="Informatieaanvraag diensten"
            conversion-id="McMQCKuxhJwYEKDetesD"
          ></contact-form>
          <p>
            Wilt u een van onze vestigingen direct bereiken? Bekijk de
            contactgegevens dan op onze
            <router-link class="link-text" to="/contact"
              >contactpagina</router-link
            >.
          </p>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import ContactForm from '../../components/ContactForm.vue'
import SiteFooter from '../../components/SiteFooter.vue'
import PrintenEnMeer from './PrintenEnMeer.vue'

export default {
  components: { SiteFooter, PrintenEnMeer, ContactForm }
}
</script>

<style lang="scss" scoped>
.archiveren {
  max-width: 360px;
}
.bestellen-bezorgen {
  max-width: 378px;
}

.kwaliteit {
  max-width: 370px;
}

.security {
  max-width: 400px;
}

.printstore {
  max-width: 365px;
}

.portals {
  max-width: 450px;
}

.form {
  margin: 20px 0;
}

.row.header {
  padding-bottom: 0;
}

.header .link-button {
  margin-bottom: 30px;
}

.image-col {
  align-self: center;
}

.img-digitaliseren {
  max-width: 394px;
}

.col-aanbesteden {
  padding-top: 0;
}

.digitaliseren {
  padding-top: 0;
}

.text-3 {
  align-items: initial;
  padding-top: 0;
  .col {
    display: flex;
    flex-direction: column;
    flex: 1;
    p {
      flex-grow: 1;
    }
  }
}

.row.image-row {
  padding-top: 20px;
  padding-bottom: 20px;

  img {
    max-width: 755px;
    margin: 0 auto;
    width: 100%;
  }
}
</style>
